export default __webpack_public_path__ + "static/media/spiral_charger.03cd6198.jpg";